@if (car) {
  <app-card [id]="'car-id-' + car.aaaid" [link]="[globals.routes()['detail'].url, car.make.slug, car.model.slug, car.id]" [title]="car.make.title + ' ' + car.model.title">
    <app-card-header>
      <app-card-important></app-card-important>
      <app-card-photo [src]="photo + '?' + globals.photoCacheVersion" [alt]="car.make.title + ' ' + car.model.title" [priority]="priority"></app-card-photo>
    </app-card-header>
    <app-card-main>
      <app-card-top>
        <div class="car-card__top-main">
          <app-card-title class="notranslate">{{ car.make.title }} {{ car.hiddenModel ? undefined : car.model.title }}{{ car.engine?.title ? ' ' + car.engine?.title : '' }}{{ car.model.lineTitle ? ', ' + car.model.lineTitle : '' }}</app-card-title>
          <app-card-list>
            @if (car.productionYear) {
              <app-card-list-item>{{ car.productionYear }}</app-card-list-item>
            }
            <app-card-list-item>{{ car.mileage | thousands }} {{ car.mileageUnit | lowercase }}</app-card-list-item>
            @if (car.engine?.is4x4) {
              <app-card-list-item>4x4</app-card-list-item>
            }
          </app-card-list>
        </div>
        <div class="car-card__top-stickers">
          @if (!car.isAvailable) {
            <app-sticker>{{ 'globals.comingSoon' | translate }}</app-sticker>
          } @else if (car.adminToolbox?.branchId === undefined || car.adminToolbox?.branchId === 356) {
            <app-sticker [color]="'primary'">{{ 'globals.inStock' | translate }}</app-sticker>
          } @else {
            <app-sticker [color]="'primary'">{{ 'globals.delivery24hours' | translate }}</app-sticker>
          }
        </div>
      </app-card-top>
      <app-card-bottom>
        <div class="car-card__prices">
          @if (car.price.cash) {
            <app-card-price [title]="'globals.price' | translate" [main]="true">{{ car.price.cash | price }}</app-card-price>
          }
          @if (car.price.cashWithoutVAT && car.price.cashWithoutVAT !== car.price.cash && car.price.isVATDeduct) {
            <app-card-price [title]="'globals.price' | translate">{{ car.price.cashWithoutVAT | price }} {{ 'globals.withoutVAT' | translate }}</app-card-price>
          }
        </div>
        @if (car.payment.defaultWithoutVat) {
          <div class="car-card__prices-monthly">
            <span class="car-card__prices-monthly-text">
              {{ 'globals.monthlyPayment' | translate }}
              <span class="car-card__prices-monthly-main">
                {{ 'globals.from' | translate | lowercase }} {{ car.payment.defaultWithoutVat | price }}
                @if (car.payment.leasingSettings && car.payment.leasingSettings.interestRate && car.payment.defaultWithoutVat && car.payment.leasingSettings.numberOfMonths) {
                  <app-icon class="car-card__prices-monthly-info" [icon]="'info'" [width]="15"></app-icon>
                }
              </span>
            </span>
            @if (car.payment.leasingSettings && car.payment.leasingSettings.interestRate && car.payment.defaultWithoutVat && car.payment.leasingSettings.numberOfMonths) {
              <span class="car-card__prices-monthly-tooltip">
                <span class="car-card__prices-monthly-tooltip-content">
                  <span>
                    {{ 'globals.interestRate' | translate }} <strong>{{ 'globals.from' | translate }} {{ car.payment.leasingSettings.interestRate | floatNumber }}%</strong>
                  </span>
                  <span>
                    {{ 'globals.monthlyPayment' | translate }} <strong>{{ car.payment.defaultWithoutVat | price }}</strong>
                  </span>
                  <span>
                    {{ 'globals.repaymentPeriod' | translate }} <strong>{{ car.payment.leasingSettings.numberOfMonths | month | async }}</strong>
                  </span>
                </span>
              </span>
            }
          </div>
        }
      </app-card-bottom>
    </app-card-main>
  </app-card>
}
